import { useState } from 'react';

import { ActionIcon, Group, Text, Textarea, Tooltip } from '@mantine/core';

import { IconCheck, IconEdit, IconX } from '@tabler/icons-react';

import type { InlineEditableTextViewProps } from './InlineEditableText.types';

export function InlineEditableTextView({
  value,
  placeholder,
  onSave,
  saving = false,
  minRows = 4,
}: InlineEditableTextViewProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(value);

  const handleSave = () => onSave(draft);

  const handleCancel = () => {
    setDraft(value);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <>
        <Textarea
          value={draft}
          onChange={(e) => setDraft(e.currentTarget.value)}
          placeholder={placeholder}
          minRows={minRows}
          autosize
          size="md"
          mb="sm"
          autoFocus
        />
        <Group gap="xs">
          <Tooltip label="Gem ændringer">
            <ActionIcon
              variant="light"
              color="green"
              onClick={() => {
                handleSave();
                setIsEditing(false);
              }}
              loading={saving}
              size="sm"
            >
              <IconCheck size={16} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="Annullér">
            <ActionIcon variant="light" color="red" onClick={handleCancel} disabled={saving} size="sm">
              <IconX size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </>
    );
  }

  return (
    <Group align="flex-start" gap="xs" style={{ cursor: 'pointer' }} onClick={() => setIsEditing(true)}>
      <Text
        size="md"
        c="dimmed"
        style={{ fontStyle: value ? 'normal' : 'italic', flex: 1, whiteSpace: 'pre-wrap' }}
      >
        {value || placeholder}
      </Text>
      <Tooltip label="Rediger">
        <ActionIcon variant="subtle" color="gray" size="sm">
          <IconEdit size={16} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
